import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ApplicationClientCommonModule, CommonUIModule, MasterDetailModule } from "@sdbn/common";
import { BarcodeReaderComponent } from "./component/barcode-reader/barcode-reader.component";
import { NumberPlateScanComponent } from "./component/number-plate-scan/number-plate-scan.component";
import { RfidReaderComponent } from "./component/rfid-reader/rfid-reader.component";
import { YardSimulatorComponent } from "./component/yard-simulator.component";

@NgModule({
  declarations: [
    YardSimulatorComponent,
    NumberPlateScanComponent,
    RfidReaderComponent,
    BarcodeReaderComponent
  ],
  imports: [
    CommonModule,
    ApplicationClientCommonModule,
    FormsModule,
    ReactiveFormsModule,
    MasterDetailModule,
    MatFormFieldModule,
    MatSelectModule,
    CommonUIModule
  ],

})
export class YardSimulatorModule { }
